import { ChangeEvent, useState } from "react";
import styles from "./NotifyMeForm.module.scss";
import SimpleForm from "@JohnLewisPartnership/jl-design-system/dist/components/form-simple/Form";
import EMAIL from "@JohnLewisPartnership/jl-design-system/dist/form/fields/email";
import { getUserEmail } from "../util/getUserEmail";
import { getNotificationsApiUrl, notifyMe } from "../util/notifyMe";
import { NotifiableEvent } from "../../../../../../types/types";
import { dispatchAnalyticsEvent } from "../../../../../../utils";
import { SIZE_SELECTOR_ERROR_NO_SIZE_SELECTED } from "../../../../../../constants/constants";

type Props = {
  pimProductId: string;
  skuId: string;
  onSuccess: () => void;
  notifiableEventType: NotifiableEvent;
  notificationsApiBaseUrl: string;
  notificationsApiKey: string;
  isSelected: boolean;
};

export const NotifyMeForm = ({
  pimProductId,
  skuId,
  isSelected,
  onSuccess,
  notificationsApiBaseUrl,
  notificationsApiKey,
  notifiableEventType,
}: Props) => {
  const [shouldShowNotifyError, setShouldShowNotifyError] = useState(false);
  const [email, setEmail] = useState(getUserEmail());

  EMAIL.value = email;
  EMAIL.placeholder = "Please enter email";
  EMAIL.label = "";

  EMAIL.onChange = (e: ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
  };

  const title = EmailMeMessaging[notifiableEventType];

  const notificationsApiUrl = getNotificationsApiUrl(
    notifiableEventType,
    notificationsApiBaseUrl,
    notificationsApiKey,
  );

  const onSubmit = async (data: Record<string, string>, done: () => void) => {
    const { email } = data;
    if (!isSelected) {
      window.dispatchEvent(
        new CustomEvent(SIZE_SELECTOR_ERROR_NO_SIZE_SELECTED),
      );
      done();
      return;
    }
    const { confirmationEmailSent, showNotifyError } = await notifyMe({
      // @ts-ignore
      email,
      pimProductId,
      skuId,
      notificationsApiUrl,
      notifiableEventType,
    });

    if (confirmationEmailSent) onSuccess();
    if (showNotifyError) setShouldShowNotifyError(true);
    done();

    dispatchAnalyticsEvent("global.emwbisSubmitted", {}, {});
  };

  return (
    <>
      <h2 data-testid="notifyme:header" className={styles.header}>
        {title}
      </h2>
      <SimpleForm
        key={skuId}
        data-testid="notifyme.form"
        fields={[EMAIL]}
        initialValues={{ email }}
        showNetworkError={shouldShowNotifyError}
        onSubmit={onSubmit}
        submitButton="Notify me"
        useV2Message
      />
    </>
  );
};

export const EmailMeMessaging: Record<NotifiableEvent, string> = {
  backInStock: "Email me when available",
  onRelease: "Email me when available",
  onPreorderLaunch: "Email me when available to pre-order",
  newlyInStock: "Email me when available",
};
